import React from 'react'
import { ChartLegend, DummyLegend, LegendItem } from './legend'
import { ChartLabelContext } from './chartJS'
import { findHighestContrastColor } from '../../utils'
import { Legend } from './pieChart'

export const ChartTitleWrapper: React.FC<{
  legendItems?: LegendItem[]
  legend?: Legend
  title?: string
  className?: string
  children: React.ReactNode
  onLabelClick?: (labels: string[]) => void
  dummyLegend?: boolean
}> = ({ legendItems, title, className, children, onLabelClick, dummyLegend, legend }) => {
  return (
    <div className={`flex min-h-0 min-w-0 flex-col items-center gap-3 overflow-hidden ${className}`}>
      {title && <div className={`text-lg font-bold ${legend?.side === 'left' ? 'self-start' : ''}`}>{title}</div>}
      <div
        className={`flex min-h-0 w-full min-w-0 overflow-hidden ${legend?.side === 'left' ? 'flex-row' : 'flex-col items-center gap-3'}`}
      >
        {legend &&
          (!dummyLegend ? (
            <ChartLegend
              items={legendItems || []}
              onLabelClick={onLabelClick}
              className={`max-w-full flex-col items-start gap-1 ${legend.className}`}
            />
          ) : (
            <DummyLegend className={legend.className} />
          ))}
        <div
          className={`relative flex aspect-square min-h-0 min-w-0 flex-grow items-center justify-center self-stretch`}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export const CHART_TOOLTIP_OPTIONS = {
  backgroundColor: '#171717',
  titleColor: 'white',
  cornerRadius: 3.5,
  boxPadding: 3,
  borderColor: '#171717',
  borderWidth: 1,
}

export const ChartLabelColoring = ({ tinyValueThreshold }: { tinyValueThreshold: number }) => {
  return function (context: ChartLabelContext) {
    const maxVal = context.chart.data.datasets.reduce((max, dataset) => {
      return dataset.data.reduce<number>((pmax, val) => {
        return Math.max(pmax, val as number)
      }, max)
    }, 0)
    const thisVal = context.dataset.data[context.dataIndex] as number
    if (thisVal < maxVal * tinyValueThreshold) return '#2f2f2f'
    const bgColors = context.dataset.backgroundColor || '#ffffff'
    // @ts-ignore
    const bgColor = typeof bgColors === 'string' ? bgColors : bgColors[context.dataIndex]
    return findHighestContrastColor(bgColor, ['#2f2f2f', '#ffffff'])
  }
}
